import LandscapeLayer from './LandscapeLayer';
import BackgroundGradient from './BackgroundGradientLinear';
import LampLayer from './LampLayer';
import GameLayer from './GameLayer';
import Hero from './objects/Hero';
import Follower from './objects/Follower';
import Villain from './objects/Villain';

export const GROUND = 220;

export default class Level extends Phaser.Group {
  constructor(game, data, catchTime) {
    super(game);

    this.data = data;

    this.reset();

    let height = this.game.height;
    let width = this.game.defaultWidth;

    //
    this.onCatchVillain = new Phaser.Signal();
    this.onGameEnd = new Phaser.Signal();
    this.onGameLost = new Phaser.Signal();

    // sky
    this.sky = new BackgroundGradient({
      game: this.game,
      defaultWidth: width,
      defaultHeight: height,
      startColour: data.sky.top,
      endColour: data.sky.bottom,
      stops: [{ stop: '0.5', clr: data.sky.bottom }],
    });
    this.addChild(this.sky);

    //create layers
    this.layers = new Array();
    for (let i = 0; i < this.data.layers.length; i++) {
      this.layers.push(new LandscapeLayer(this.game, this.data.layers[i], height));
      this.addChild(this.layers[i]);
    }
    this.layers.push(new GameLayer(this.game, this, this.data, height));
    this.gameLayer = this.layers[this.layers.length - 1];
    this.addChild(this.gameLayer);

    //
    this.hero = new Hero(
      this.game,
      this,
      350,
      this.data.height - this.data.ground,
      this.data.characters[0],
      this.data.height
    );
    this.gameLayer.addHero(this.hero);

    // followers
    this.followers = [];
    for (let i = 0; i < 4; i++) {
      let leader;
      let character = this.data.characters[1 + i];
      let delay = 100; // max 500
      if (i == 0) {
        leader = this.hero;
      } else {
        leader = this.followers[i - 1];
      }
      let x = leader.x;
      let y = leader.y;
      let follower = new Follower(this.game, x, y, character, leader, 50, delay);
      this.gameLayer.addFollower(follower);
      this.followers.push(follower);
    }

    //
    this.gameLayer.sortHeroes();

    // villain - (game, x, y, canBeCaught, levelHeight)
    this.villain = new Villain(
      this.game,
      -200,
      this.data.height - this.data.ground,
      this.data.catch_villain,
      catchTime,
      this.data.height
    );
    this.gameLayer.addVillain(this.villain);

    //
    this.hero.villainRef = this.villain;
  }

  start() {
    this.hero.start();
  }

  reset() {
    this.distance = 0;
    this.shakeTime = 0;
  }

  step(dt, timeLeft) {
    this.hero.step(dt);
    if (this.hero.isRunning()) {
      // step on GameLayer
      this.gameLayer.step(dt, timeLeft);

      // scroll all layers
      let y = this.hero.getNormalizedY();
      for (let i = 0; i < this.layers.length; i++) {
        this.layers[i].scroll(this.hero.m_speedX * dt, y);
      }

      // check if villain caught
      // if (this.data.catch_villain) {
      //   if (this.hero.onPositionToCatch && this.villain.onPositionToCatch) {
      //     this.onCatchVillain.dispatch();
      //     this.stopAllCharacters();
      //   }
      // }
    } else if (this.hero.isGoingBack()) {
      // step on GameLayer
      //this.gameLayer.step(dt, timeLeft);

      // scroll all layers
      let y = this.hero.getNormalizedY();
      for (let i = 0; i < this.layers.length; i++) {
        this.layers[i].scroll(this.hero.m_speedX * dt, y);
      }
    } else {
      // set y layers
      let y = 0; //this.hero.getNormalizedY();
      for (let i = 0; i < this.layers.length; i++) {
        this.layers[i].scroll(0, y);
      }
    }

    // followers
    for (let i = 0; i < this.followers.length; i++) {
      this.followers[i].step(dt);
    }

    // villain
    this.villain.step(dt, this.gameLayer.obstacles);
  }

  endLevel() {
    // make characters run out of the screen
    this.hero.exit();
    for (let i = 0; i < this.followers.length; i++) {
      this.followers[i].exit();
    }
    this.villain.exit();
  }

  gameLost() {
    this.hero.goBack();
    // for (let i = 0; i < this.followers.length; i++) {
    //   this.followers[i].exit();
    // }
    this.villain.exit();

    this.onGameLost.dispatch();
  }

  stopAllCharacters() {
    // stop all anims
    this.hero.pause();
    for (let i = 0; i < this.followers.length; i++) {
      this.followers[i].pause();
    }
    this.villain.pause();
  }

  vanishPickups() {
    // this.layers[2].vanishPickups();
  }

  gameOver(won) {
    this.onGameEnd.dispatch(won);
  }

  stopController() {
    // this.playRef.stopController();
  }
}



// WEBPACK FOOTER //
// ./js/app/games/chase/game/Level.js